import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "vab-search-trigger hidden-xs-only"
};
const _hoisted_2 = {
  class: "vab-spotlight-card"
};
const _hoisted_3 = {
  class: "vab-spotlight-input-wrap"
};
const _hoisted_4 = ["placeholder"];
const _hoisted_5 = {
  key: 0,
  class: "vab-spotlight-history-wrap"
};
const _hoisted_6 = {
  class: "vab-spotlight-history"
};
const _hoisted_7 = {
  class: "vab-spotlight-history-list"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "vab-spotlight-list"
};
const _hoisted_10 = ["onMousedown", "onMouseenter"];
const _hoisted_11 = {
  class: "vab-spotlight-item-content"
};
const _hoisted_12 = {
  class: "vab-spotlight-item-title"
};
const _hoisted_13 = {
  class: "vab-spotlight-item-path"
};
const _hoisted_14 = {
  key: 0,
  class: "vab-spotlight-empty"
};
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vab_icon = _resolveComponent("vab-icon");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("span", _hoisted_1, [_createVNode(_component_vab_icon, {
    icon: "search-line",
    title: "菜单搜索 ({{ isMac ? '⌘+K' : 'Ctrl+K' }})",
    onClick: $setup.openSearch
  })]), (_openBlock(), _createBlock(_Teleport, {
    to: "body"
  }, [_createVNode(_Transition, {
    name: "fade"
  }, {
    default: _withCtx(() => [$setup.show ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "vab-spotlight-mask",
      onClick: _withModifiers($setup.closeSearch, ["self"])
    }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_vab_icon, {
      class: "vab-spotlight-input-icon",
      icon: "search-line"
    }), _withDirectives(_createElementVNode("input", {
      ref: "inputRef",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.search = $event),
      autocomplete: "off",
      class: "vab-spotlight-input",
      placeholder: $setup.isMac ? '搜索菜单… (⌘+K)' : '搜索菜单… (Ctrl+K)',
      onKeydown: $setup.onInputKeydown
    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_4), [[_vModelText, $setup.search]])]), $setup.searchHistory.length ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
      class: "vab-spotlight-history-title"
    }, [_cache[1] || (_cache[1] = _createTextVNode(" 搜索历史 ", -1 /* CACHED */)), _createElementVNode("span", {
      class: "vab-spotlight-history-clear",
      onClick: $setup.clearHistory
    }, " 清空 ")]), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.searchHistory, item => {
      return _openBlock(), _createElementBlock("span", {
        key: item,
        class: "vab-spotlight-history-item"
      }, [_createElementVNode("span", {
        onClick: $event => $setup.selectHistory(item)
      }, _toDisplayString(item), 9 /* TEXT, PROPS */, _hoisted_8), _createVNode(_component_vab_icon, {
        class: "vab-spotlight-history-del",
        icon: "close-circle-fill",
        onClick: _withModifiers($event => $setup.removeHistory(item), ["stop"])
      }, null, 8 /* PROPS */, ["onClick"])]);
    }), 128 /* KEYED_FRAGMENT */))])])])) : _createCommentVNode("v-if", true), _createElementVNode("ul", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredMenus, (item, idx) => {
      return _openBlock(), _createElementBlock("li", {
        key: item.path + item.title,
        class: _normalizeClass(['vab-spotlight-item', {
          active: idx === $setup.activeIndex
        }]),
        onMousedown: _withModifiers($event => $setup.onItemClick(idx), ["prevent"]),
        onMouseenter: $event => $setup.activeIndex = idx
      }, [item.icon ? (_openBlock(), _createBlock(_component_vab_icon, {
        key: 0,
        class: "vab-spotlight-item-icon",
        icon: item.icon
      }, null, 8 /* PROPS */, ["icon"])) : _createCommentVNode("v-if", true), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(item.title), 1 /* TEXT */), _createElementVNode("div", _hoisted_13, _toDisplayString(item.path), 1 /* TEXT */)])], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_10);
    }), 128 /* KEYED_FRAGMENT */)), $setup.filteredMenus.length === 0 ? (_openBlock(), _createElementBlock("li", _hoisted_14, [!$setup.search ? (_openBlock(), _createElementBlock("div", _hoisted_15, "请输入关键词进行搜索")) : (_openBlock(), _createElementBlock("div", _hoisted_16, "无匹配菜单"))])) : _createCommentVNode("v-if", true)])])])) : _createCommentVNode("v-if", true)]),
    _: 1 /* STABLE */
  }), _createElementVNode("button", {
    class: "vab-spotlight-fab",
    title: "菜单搜索 ({{ isMac ? '⌘+K' : 'Ctrl+K' }})",
    onClick: $setup.openSearch
  }, [_createVNode(_component_vab_icon, {
    icon: "search-line"
  })])]))], 64 /* STABLE_FRAGMENT */);
}